import script from "./FormInputV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormInputV2.vue?vue&type=script&setup=true&lang=ts"

import "./FormInputV2.vue?vue&type=style&index=0&id=5767f2ce&scoped=true&lang=css"

import exportComponent from "/node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5767f2ce"]])

export default __exports__